import { useEffect, useState } from "react";
import "../styles/singlepost.scss";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../components/header";
import Footer from "../components/footer"
import MenuTab from "../components/menu_tab";
import Banner from "../components/banner";
import PostItem from "../components/post_item";
import newconnapplicationform from "../assets/docs/newconnectionform.pdf";
import cis from "../assets/imgs/cis.png";
import pe from "../assets/imgs/publicparticipation.jpeg";
import waterinterruptiongatamaiyu from "../assets/imgs/waterinterruptiongatamaiyu.jpg";
import waterrestoredgatamaiyu from "../assets/imgs/waterrestoredgatamaiyu.jpg";
import PostItems from "../components/posts/postItems";

export default function SinglePost (props) {
    const { state } = useLocation();
    const navigate = useNavigate();
    const id = window.location.pathname.split("/")[3];
    const [toggleMenu, setToggleMenu] = useState(false);
    const [data, setData] = useState(null);

    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        fetch(`/api/news/${id}`)
          .then((res) => {
            if (res.ok) return res.json();
            else throw Error("");
          })
          .then((data) => {
            
            setData(data)
          })
          .catch((e) => {});
    }, []);

    // Rotate images every 3 seconds
    useEffect(() => {
        const images = data?.Images
        const interval = setInterval(() => {
        if (images && images.length > 1) {
            setCurrentImageIndex((prevIndex) =>
            (prevIndex + 1) % images.length
            );
        }
        }, 3000); // Change every 3 seconds

        return () => clearInterval(interval); // Cleanup
    }, [data]);
    

    return (
        <div className="body">
            <Banner />
            <Header toggleMenu={toggleMenu} 
                setToggleMenu={setToggleMenu}
            />
            {toggleMenu && <MenuTab toggleMenu={toggleMenu} 
                setToggleMenu={setToggleMenu}
            />}
            <div className="image2">
                <div id="newconnection">
                <p>News & Events</p>
                </div>
            </div>
            {data && <div className="single-post">
                <div className="post-container">
                    {/* Title */}
                    <h1 className="post-title">{data.Title}</h1>

                    {/* Date */}
                    <p className="post-date">{data.Date}</p>

                    {/* First Image */}
                    <div className="post-image">
                        <img src={`/api/${data.Images?.[currentImageIndex]}`} alt="" />
                    </div>

                    {/* Post Content */}
                    <div
                        className="post-details"
                        dangerouslySetInnerHTML={{ __html: data.Description }}
                    ></div>
                </div>

                {/* Back Button */}
                <div className="back-button-container">
                    <button className="back-button" onClick={() => navigate(-1)}>
                        &larr; Back
                    </button>
                </div>
            </div>}

            <Footer />
        </div>
    );
};